import sliceCreator from '../../index.jsx';
import {CREATE_PRE_SEASON_ACTIVITY} from '../../../constants/index.jsx';
const _createPreSeasonActivityAction = sliceCreator('CREATE_PRE_SEASON_ACTIVITY', CREATE_PRE_SEASON_ACTIVITY, 'post');

const { asyncAction: createPreSeasonActivityAction, reducer, clearData: clearCreatePreSeasonActivityAction } = _createPreSeasonActivityAction;

export default reducer;

export {
    createPreSeasonActivityAction,
    clearCreatePreSeasonActivityAction
}